import { Block } from 'components/Block'
import { GuidebookStep } from 'components/content/guidebook/content'
import {
  SCaption,
  SImageWrapper,
  SText,
  STextWrapper,
  STitle,
  SWrapper,
} from './GuidebookStepHeader.styled'
import { useTranslation } from 'next-i18next'
import { ReactNode } from 'react'

export function GuidebookStepHeader(props: {
  step: GuidebookStep
  description: ReactNode
  image?: ReactNode
}) {
  const { t } = useTranslation('eol_guide')

  return (
    <Block id={props.step.id}>
      <SWrapper>
        <STextWrapper>
          <SCaption>{t('eol_guide.step_x', { step: props.step.no })}</SCaption>
          <STitle as="h2" variant={['h5', 'h3']}>
            {t(`eol_guide.step_names.${props.step.no}`)}
          </STitle>
          <SText>{props.description}</SText>
        </STextWrapper>
        <SImageWrapper>{props.image}</SImageWrapper>
      </SWrapper>
    </Block>
  )
}
